import { render } from "./mute-multiselect.vue?vue&type=template&id=23e484a3"
import script from "./mute-multiselect.vue?vue&type=script&lang=js"
export * from "./mute-multiselect.vue?vue&type=script&lang=js"

import "./mute-multiselect.vue?vue&type=style&index=0&id=23e484a3&lang=scss"

import exportComponent from "/tmp/build_b6f5290c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__